/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { intervalsOptions } from 'reports/utils/constants';
const getArrayOfValues = (array: any) =>
  Array.isArray(array)
    ? array?.map((item: any) => item?.value).filter(Boolean)
    : [];
const getArrayOfOptions = (array: any) =>
  Array.isArray(array)
    ? array?.map((item: any) => ({ label: item, value: item })).filter(Boolean)
    : [];
export const dataTransformer = ({
  isCompare,
  id,
  compareValues,
  name,
  params,
  values,
  isGroup,
}: any) => {
  const newData: any = {
    name: Array.isArray(name) ? name?.join() : name,
    schedule_request: {},
    id,
    type: isGroup ? 'GROUP' : isCompare ? 'COMPARE' : 'REPORT',
    items: isCompare
      ? compareValues
      : [
          {
            id: +id,
            name,
          },
        ],
  };

  const excludeKeys = [
    'moduleName',
    'itemsName',
    'id',
    'schedule_status',
    'type',
  ];

  for (const key in values) {
    const element = values[key];

    switch (key) {
      case 'report_template':
        newData['template_id'] = element?.value;
        break;
      case 'allow_blank_description':
        newData['allow_blank_description'] = element;
        break;
      // case 'sections':
      //   newData[key] = element.filter(
      //     (item: any) => item.title && item.description
      //   );
      //   break;
      case 'days':
        newData.schedule_request['days'] = Array.isArray(element)
          ? element
          : [element].filter(Boolean);
        break;
      case 'email_subject':
        newData.schedule_request[key] = element;
        break;

      case 'recipients':
        newData.schedule_request[key] = getArrayOfValues(element);
        break;
      case 'recipients_cc':
        newData.schedule_request[key] = getArrayOfValues(element);
        break;
      case 'recipients_bcc':
        newData.schedule_request[key] = element?.map(
          (item: any) => item?.value
        );
        break;
      case 'schedule_description':
        newData.schedule_request['email_body'] = element;
        break;

      case 'format':
        newData.schedule_request[key] = Array.isArray(element)
          ? element
          : [element];
        break;
      case 'intervals':
        newData.schedule_request['interval'] = element;
        break;
      case 'start_date':
        newData.schedule_request['start_date'] = element || '';
        break;

      case 'day_of_month':
        newData.schedule_request['day_of_month'] = element?.value;
        break;
      case 'id':
        newData.items['id'] = +params?.id || values?.report_id;
        break;
      case 'schedule_status':
        newData.schedule_request[key] = element;
      default:
        if (!excludeKeys.includes(key))
          if ((Array.isArray(element) && element.length) || element)
            newData[key] = element;

        break;
    }
  }
  return newData;
};

export const transformData = (res: any, id: any) => {
  return {
    report_template: {
      label: res?.template?.name,
      value: res?.template?.id,
    },
    description: res?.description,
    sections: res?.sections?.length
      ? res?.sections
      : [{ title: '', description: '' }],
    intervals:
      res?.schedule_email?.interval?.length > 0
        ? res?.schedule_email?.interval
        : intervalsOptions?.[0]?.value,
    days_of_Week: res?.schedule_email?.days_of_Week,
    email_subject: res?.schedule_email?.email_subject,
    schedule_status: res?.schedule_email?.schedule_status,
    recipients: getArrayOfOptions(res?.schedule_email?.recipients),
    recipients_cc: getArrayOfOptions(res?.schedule_email?.recipients_cc),
    recipients_bcc: getArrayOfOptions(res?.schedule_email?.recipients_bcc),
    schedule_description: res?.schedule_email?.email_body,
    format:
      res?.schedule_email?.format?.length === 1
        ? res?.schedule_email?.format?.[0]
        : [...res?.schedule_email?.format],
    days:
      res?.schedule_email?.days?.length === 1
        ? res?.schedule_email?.days?.[0]
        : res?.schedule_email?.days,
    day_of_month: {
      label: res?.schedule_email?.day_of_month,
      value: res?.schedule_email?.day_of_month,
    },
    report_id: +id,
    id: +id,
    start_date: res?.schedule_email?.start_date,
    charts: res?.charts,
    status: res?.status,
    items: res?.items,
    name: res?.name,
    type: res?.type,
    allow_blank_description: res?.allow_blank_description,
  };
};
